<template>
  <div class="tap-box" :style="{ 'height': fullHeight, 'margin-bottom': marginBottom + 'px' }">
    <div class="tap-ul" v-if="alertText">
      <div class="top-title" :style="{

        'font-size': titleSize + 'px',
        'margin-right': padding + 'px',

        'margin-left': padding + 'px'
      }">{{
  topAlert
}}</div>
      <div class="alert-box" :style="{
            'line-height': lheight + 'px',
            'font-size': size + 'px',
            'min-height': min,
            'padding-right': padding + 'px',
            'padding-left': padding + 'px',
            'padding-top': pad + 'px',
            'padding-bottom': pad + 'px',
            'width': width ? 'calc(' + width + '-' + padding + '-' + padding + ')' : 310 - padding - padding + 'px',
            'font-family': family,
          }">
        {{ alertText }}
      </div>
      <div class="btn-box" @click="click(alertBtn)" :style="{
        'padding-right': padding + 'px',
        'padding-left': padding + 'px'
      }">
        <Btn class="alert-btn" :text="alertBtn"></Btn>
      </div>
    </div>
    <ul class="tap-ul" v-else :style="{ 'margin-top': margin + 'px', 'margin-bottom': margin + 'px' }">
      <div class="top-title" :style="{
        'font-size': titleSize + 'px', 'margin-right': padding + 'px',
        'margin-left': padding + 'px'
      }" v-if="topAlert">{{
  topAlert
}}</div>

      <li class="tap-li" :class="notActive ? {} : { active: checked == index }" @click="checkLi(item, index)"
        v-for="(item, index) in keys" :style="{
          'line-height': lheight + 'px',
          'font-size': size + 'px',
          'min-height': min,
          'border-radius': radius,
          'padding-right': padding + 'px',
          'padding-left': padding + 'px',
          'padding-top': pad + 'px',
          'padding-bottom': pad + 'px',
          'width': width ? 'calc(' + width + '-' + padding + '-' + padding + ')' : 310 - padding - padding + 'px',
          'font-family': family,
          'text-transform': textTransform,
        }" :key="index">
        <span v-html="item.rendered ? item.rendered : htmlDecode(item)">

        </span>
      </li>
    </ul>
  </div>
</template>
<script>
import Btn from "./Btn.vue";
export default {
  components: { Btn },
  name: "SideTap",
  props: [
    "radius",
    "min",
    "pad",
    "title",
    "keys",
    "textTransform",
    "size",
    "padding",
    "margin",
    "lheight",
    "family",
    "topAlert",
    "titleSize",
    "fullHeight",
    "alert",
    "alertText",
    "alertBtn",
    "marginBottom",
    "notActive",
    "width"
  ],
  data() {
    return {
      checked: null,
      titles: "",

    };
  },
  mounted() {
    // if (!this.notActive) {
    //   this.beforeChecked();
    // }
    var count = 0
    let timer = setInterval(() => {
      count++
      if (count >= 50) {
        clearInterval(timer)
      }

      if (this.$store.state.class != '' && !this.notActive) {
        this.beforeChecked()
        clearInterval(timer)
      }
    }, 200)

  },
  methods: {
    decodeHTMLEntities(input) {
      const entities = {
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&quot;': '"',
        '&#39;': "'"
        // 可根据需要添加其他转义字符和对应的替换值
      };

      return input.replace(/&amp;|&lt;|&gt;|&quot;|&#39;/g, match => entities[match]);
    },
    htmlDecode(s) {
      var doc = new DOMParser().parseFromString(s, "text/html");
      return doc.documentElement.textContent;
    },
    getQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      console.log(reg);
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return decodeURI(r[2]); return null;
    },

    click(value) {
      console.log(value);
      this.$parent.click(value)
    },
    beforeChecked() {
      console.log(this.$store.state.class);
      this.$store.state.class.map((item, index) => {
        if (item.id == this.$route.hash.replaceAll('#topic=', '')) {
          this.checked = index
        }
      })
      // this.$store.state.class.map((item) => {
      //   item.subClassifications.map((it, index) => {
      //     console.log(this.$route.params.name);
      //     if (it.id == this.$route.params.name) {
      //       this.checked = index
      //     }
      //   })

      // })
    },
    checkLi(item, index) {
      console.log(item, index);
      if (!this.notActive) {
        this.checked = index;
        var isMain = false
        this.$store.state.class.map(it => {
          console.log(it.name == item);

          if (it.name == item) {
            console.log("111")
            isMain = true
            this.$router.push({
              path: '/faq#topic=' + it.id
            })
            this.checked = index
          }
        })
        if (!isMain) {

          this.$store.state.class.map(items => {

            items.subClassifications.map(it => {
              console.log(it.name == item);
              if (it.name == item) {

                this.$router.push({
                  path: '/faq/' + it.id
                })
                this.checked = index
              }
            })
          })
        }

      } else {

      }
      this.$parent.clickArt(item)
    },
  },
  created() { },
};
</script>
<style lang="scss" scoped>
#btn {
  font-size: 18px
}

@import "../assets/scss/sidetap.scss";
</style>